// extracted by mini-css-extract-plugin
export default {"staff-card":"staffCard_staff-card__ZUayO","staff-card__text":"staffCard_staff-card__text__2xS4c"};